export const DEPLOY_STALE_MS = 60000;
const FUTURE_SKEW_MS = 5000;
export function isDeployInProgress(payload, nowMs) {
    if (payload === null || typeof payload !== 'object')
        return false;
    const record = payload;
    if (record.status !== 'building')
        return false;
    if (typeof record.updatedAt !== 'number' || !Number.isFinite(record.updatedAt))
        return false;
    const ageMs = nowMs - record.updatedAt * 1000;
    return ageMs <= DEPLOY_STALE_MS && ageMs >= -FUTURE_SKEW_MS;
}
// updatedAt vem do relógio da VM; comparar com o relógio do PC do usuário faz o toast piscar.
export function serverNowMs(dateHeader, fallbackMs) {
    if (!dateHeader)
        return fallbackMs;
    const parsed = Date.parse(dateHeader);
    return Number.isFinite(parsed) ? parsed : fallbackMs;
}
